/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {WarningEl} from 'common/components/warning';
import {WarningHeroEl} from 'common/widgets/warning-hero';
import {WarningHeroReportName, WarningHeroTheme} from 'common/widgets/warning-hero/constants';
import {SensitiveDataHero} from 'common/widgets/warning-hero/presets';

import {CodeTipEl} from '../components/code-tip';
import {Section, SubSection} from './utils';

export function ErrorsSection() {
  return (
    <Section title='Errors and Empty Reports'>
      <SubSection title='mp-warning' autoDoc={true}>
        <p sel='.desc'>Component for displaying errors and empty report states</p>
        <h5>Theme: default</h5>
        <CodeTipEl sel='.example'>
          <WarningEl
            attrs={{
              'header-text': `Something happened`,
              'body-text': `Oh no!`,
              'cta-text': `Do stuff`,
              'cta-href': `#mp-warning`,
            }}
          />
        </CodeTipEl>
        <h5>Theme: error</h5>
        <CodeTipEl sel='.example'>
          <WarningEl
            attrs={{
              'body-text': `The property "no-mapped-property" is no longer available for use. \n Please use another property or contact your project admin`,
              'header-text': `Unable to Display Data`,
              theme: `error`,
            }}
          />
        </CodeTipEl>
        <h5>Theme: no data</h5>
        <CodeTipEl sel='.example'>
          <WarningEl
            attrs={{
              'header-text': `We couldn't find any data for your query`,
              theme: `no-data`,
            }}
          />
        </CodeTipEl>
        <h5>Theme: sensitive</h5>
        <CodeTipEl sel='.example'>
          <WarningEl
            attrs={{
              'body-text': `Report contains classified data`,
              'header-text': `Report contains classified data`,
              theme: `sensitive`,
            }}
          />
        </CodeTipEl>
        <h5>Theme: no icon</h5>
        <CodeTipEl sel='.example'>
          <WarningEl
            attrs={{
              'header-text': `No User Profile Properties`,
              'cta-text': `Setup User Profile Properties`,
              'cta-href': `https://developer.mixpanel.com/reference/user-profiles#profile-set`,
              theme: `no-icon`,
            }}
          />
        </CodeTipEl>
      </SubSection>

      <SubSection title='mp-warning-hero' autoDoc={true}>
        <p sel='.desc'>
          Wrapper of mp-warning component. It adds an extra theme "empty-report", tracks some events and exposes
          presets.
        </p>
        <CodeTipEl sel='.example'>
          <WarningHeroEl
            attrs={{
              'body-text': `Learn [Board Basics](/#link) or explore [Example Boards](/#other-link)`,
              'header-text': `Add a report to your board.`,
              report: WarningHeroReportName.Dashboards,
              theme: WarningHeroTheme.EmptyReport,
            }}
          />
        </CodeTipEl>

        <CodeTipEl sel='.example.block'>
          <SensitiveDataHero
            reportName={WarningHeroReportName.Insights}
            bodyText='Custom body text for this preset goes here'
          />
        </CodeTipEl>
      </SubSection>
    </Section>
  );
}
